import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const TESTIMONIALS = [
  {
    img: '/images/testimonials/Hital Shah.jpg',
    name: 'Hital Shah',
    desig: 'MIT BE CIVIL 1993-94',
    short: '"I was his class student from the year 1991 to 1993 to learn structural engineering. I am his student for life to learn the principles of life. One extraordinary knack that sir has while he teaches on the board, is the excellent way he can use the full board and his straight upright writing that clears all the concepts with smoothness is unbeatable.',
    full: ' I rarely have seen any teacher who can use the board so efficiently. The methodical way in which we have learnt the subjects from him are a true reflection of his personality which is very straight forward and quite a logical approach to everything in life. I really wish him all the best for his new endeavor in digital study platform. May God keep sir Healthy always. Jai shree krishna."',
  },
  {
    img: '/images/testimonials/Suhas Mohol.jpg',
    name: 'Suhas Mohol',
    desig: '',
    short: '"It was real insight and thoughtfulness on each lecture you had conducted during our classes 20 years back. Structural engineering became more interesting because of your teaching and that is the reason I personally chose structural domain in my career. I have hardly seen a dedicated and committed teacher like you.',
    full: ' Your fluid presentation on board was a treat to our eyes and these values are inculcated in our lives. Your books and notes are still used as a manual. Once again thanks for being our teacher and showing us the path."',
  },
  {
    img: '/images/testimonials/Amit Dhulekar.jpg',
    name: 'Amit Nandkishor Dhulekar',
    desig: 'Real Estate Developer',
    short: 'I still remember that we used to reach the Class of SOM and various other subjects till my final year of BE early morning at 7am from Nigdi. We never dared to be late, not because you were strict but we could not imagine missing a minute of your teaching.',
    full: " Your Insistence of using a Hard Cover Book to take down notes was worth as I could carry and refer those notes even while doing my MS. From bottom of my Heart I would like to thank you for making us 'Better Engineers'.",
  },
  {
    img: '/images/testimonials/Prafull Aher.jpg',
    name: 'Prafull Kisan Aher',
    desig: '2004',
    short: '"To describe Sir in simple words is that he is like "Krishna" and we students as "Arjuna" in Bhagavad Gita. As a student we face many doubts during the course of our education and Sir has been my mentor like Krishna always guiding me throughout it.',
    full: ' I would like to express my deep gratitude for your generous support and teachings that has been a part of me for what I am today."',
  },
  {
    img: '/images/testimonials/Shweta Lokhande.jpg',
    name: 'Shweta Lokhande',
    desig: '',
    short: 'H.M. Somayya - the popular class for the most dreaded subject of "Applied Mechanics"! Somayya Engineering Academy is truly a savior for all civil engineering students. The entire journey of structural engineering becomes a pleasure if taught by Somayya sir.',
    full: ' It helped me clear all structural engineering subjects with reasonable grades, helped me crack GATE as well as MPSC Civil exam. I definitely recommend this academy to every student.',
  },
  {
    img: '/images/testimonials/Suhrud Kulkarni.JPG',
    name: 'Suhrud Kulkarni',
    desig: '2012',
    short: '"Somayya Sir is an epitome of knowledge, discipline and positivity. His dedication to teaching and imparting education is unparalleled. I was a student of Somayya Sir throughout my Bachelor\'s in Civil Engineering.',
    full: " Sir's passion to provide a better quality of education to everyone makes him stand out and the Academy an incubator for development of young minds.",
  },
  {
    img: '/images/testimonials/Saket Thombre.jpg',
    name: 'Saket Thombre',
    desig: '',
    short: '"When I decided to join tuition for engineering mechanics, I thought about Somayya Academy for its excellent track record of mentoring students. At Somayya Academy, I found a caring, nurturing, and engaging environment to develop myself.',
    full: ' I am truly thankful to Somayya Academy to give me the knowledge and confidence to achieve my goals."',
  },
  {
    img: '/images/testimonials/Vicky Punjabi.jpg',
    name: 'Vicky Punjabi',
    desig: 'Year of Passing - 2016 (B.E., Civil) & 2020 (MTech, Structures)',
    short: '"Somayya Academy has been the most enthralling journey of my life. H M Somayya sir is a blend of experience and wisdom with energy and enthusiasm. He has been highly supportive throughout my journey of four years.',
    full: ' The examples practiced in classroom teaching were applicative to the industrial requirements. I owe my gratitude to respected H M Somayya sir."',
  },
  {
    img: '/images/testimonials/Purva Vaidya.jpg',
    name: 'Purva Vaidya',
    desig: '2016',
    short: "I'm a student of Somayya sir from 2016 and will be his student forever. Somayya sir's way of teaching is so unique that it is impossible to forget the concepts once taught.",
    full: " Sir has been an inspiration to me in various aspects of life and will always be my mentor. His love and support towards his students is immeasurable.",
  },
  {
    img: '/images/testimonials/Purva More.jpg',
    name: 'Purva More',
    desig: '2018',
    short: "I joined Somayya Academy for 'Strength of Materials'. Somayya sir's teaching method is very effective. He provided enough practice problems and exposure for students to attempt on different topics with varying degree of difficulty.",
    full: " His classes are the most effective as my grades constantly improved and helped me rank first in SOM Subject during my undergrad. Thank you, Sir!!",
  },
  {
    img: '/images/testimonials/Ramvilas Kendre.jpg',
    name: 'Ramvilas Shivajirao Kendre',
    desig: '2016',
    short: 'I remember first day at Somayya Academy, I joined for Mechanics tuition for first year of engineering. Somayya sir always focused on clearing our basic concepts and never thought of taking any short cuts.',
    full: ' Somayya Academy feels like a sacred temple and Sir is like a priest who is always there for blessing and guiding us.',
  },
  {
    img: '/images/testimonials/Rutuja Patil.png',
    name: 'Rutuja Patil',
    desig: '2021',
    short: 'I joined the academy for learning Strength of Materials (SOM) and since then I have been under the guidance of Somayya Sir. He really has a very unique way of teaching and the knowledge he shares is a definite eye-opener.',
    full: ' His dedication, work, and approach inspired me to learn each concept in depth. I am grateful to have him as my mentor.',
  },
];

const FALLBACK = '/images/Somayya-Academy-Best-Coaching-Classes-in-Pune.png';

function TestiCard({ t }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="sa-testi-card">
      {/* Profile photo — absolutely positioned top-right, matches original */}
      <div className="sa-testi-img">
        <img
          src={t.img}
          alt={t.name}
          onError={e => { e.target.src = FALLBACK; }}
        />
      </div>

      {/* Name, designation, stars */}
      <h3 className="sa-testi-name"><a>{t.name}</a></h3>
      {t.desig && <span className="sa-testi-desig">{t.desig}</span>}
      <ul className="sa-testi-stars">
        {[1,2,3,4,5].map(n => <li key={n}><i className="fa fa-star" aria-hidden="true" /></li>)}
      </ul>

      {/* Quote bubble — grey box with arrow on top */}
      <div className="sa-testi-text">
        {t.short}
        {!expanded && t.full && (
          <button className="sa-read-more" onClick={() => setExpanded(true)}>
            ...Read more
          </button>
        )}
        {expanded && (
          <>
            {t.full}
            <button className="sa-read-more" onClick={() => setExpanded(false)}>
              {' '}Less
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="sa-testimonials">
      <h2 className="sa-testimonials-title">What Our Students Say</h2>
      <div className="sa-container">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 6000, disableOnInteraction: false }}
          loop
          spaceBetween={30}
          breakpoints={{
            0:   { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
        >
          {TESTIMONIALS.map((t, i) => (
            <SwiperSlide key={i}>
              <TestiCard t={t} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
